import {Languages} from './';

export const supportedHtmlNodes = [
  'b',
  'br',
  'em',
  'i',
  'li',
  'p',
  'strong',
  'ul',
];

/**
 * Detect the appropriate locale code from a URL pathname (or a default if none
 * can be detected).
 *
 * @param pathname URL pathname component to check.
 * @param supportedLanguages List of languages supported by this site.
 */
export const getLanguageCodeFromPathname = (
  pathname: string,
  supportedLanguages: Languages[],
): string => {
  const parts = pathname.match(/\/([a-zA-Z-]*)/g);
  if (parts?.length) {
    const language = supportedLanguages.find(l => parts[0] === l.path);
    if (language) {
      return language.code;
    }
  }
  return 'en-us';
};

/**
 * Retrieve a language object by code.
 *
 * @param code Language code.
 * @param supportedLanguages List of languages supported by this site.
 */
export const getLanguageByCode = (
  code: string,
  supportedLanguages: Languages[],
): Languages | undefined => {
  return supportedLanguages.find(lang => lang.code === code);
};
